import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PartnerIntegrationPage from './page';
import IntegrationRequestService from './service';
import { fetchIntegrationRequests } from './actions';
import {
    getIntegrationRequests,
    getIntegrationRequestsError,
    getIntegrationRequestsLoaded,
    getIntegrationRequestsLoading,
} from '../selectors/partnerIntegration';

const service = new IntegrationRequestService();

const PartnerIntegrationContainer = ({ requests, loading, loaded, error = null, onRefreshRequests }) => {
    useEffect(() => {
        if (!loaded && !loading) {
            onRefreshRequests();
        }
    }, [loaded, loading, onRefreshRequests]);

    return <PartnerIntegrationPage requests={requests} loading={loading} loaded={loaded} error={error} />;
};

PartnerIntegrationContainer.propTypes = {
    requests: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            request_type: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            form_data: PropTypes.shape({}),
            adnetwork_id: PropTypes.number,
            platform_template: PropTypes.string,
            zendesk_ticket_id: PropTypes.string,
            submitted_at: PropTypes.string,
            reviewed_at: PropTypes.string,
            reviewer: PropTypes.string,
            reviewer_comments: PropTypes.string,
            created_at: PropTypes.string,
            updated_at: PropTypes.string,
        })
    ).isRequired,
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onRefreshRequests: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    requests: getIntegrationRequests(state),
    loading: getIntegrationRequestsLoading(state),
    loaded: getIntegrationRequestsLoaded(state),
    error: getIntegrationRequestsError(state),
});

const mapDispatchToProps = dispatch => ({
    onRefreshRequests: () => fetchIntegrationRequests({ dispatch, service }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerIntegrationContainer);
